import { render } from "./PlaylistEditComponent.vue?vue&type=template&id=1489dc0e&scoped=true"
import script from "./PlaylistEditComponent.vue?vue&type=script&lang=js"
export * from "./PlaylistEditComponent.vue?vue&type=script&lang=js"

import "./PlaylistEditComponent.vue?vue&type=style&index=0&id=1489dc0e&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1489dc0e"]])

export default __exports__